import {
  Header,
  HeaderPortal,
  MainToolbar,
  Menu,
  MenuItem,
  MenuSpacer,
  SubMenuItem,
} from '@interhyp/platform-navigation';
import React from 'react';

import styles from './Navigation.module.scss';
import { CompanyLogo } from './components/ComanyLogo/CompanyLogo';
import { useRoutes } from '../../hooks/useRoutes';

export function Navigation() {
  const menuItems = useRoutes();

  return (
    <>
      <Header />
      <HeaderPortal>
        <MainToolbar>
          <CompanyLogo />
          <MenuSpacer />
          <Menu className={styles.menu}>
            {menuItems
              .filter(menuItem => !menuItem.hidden)
              .map(menuItem => {
                return (
                  <MenuItem label={menuItem.title} key={menuItem.path} to={menuItem.path}>
                    {menuItem.children &&
                      menuItem.children
                        .filter(menuItem => !menuItem.hidden)
                        .map(subMenuItem => {
                          return (
                            <SubMenuItem
                              key={subMenuItem.path}
                              label={subMenuItem.title}
                              to={subMenuItem.path}
                            />
                          );
                        })}
                  </MenuItem>
                );
              })}
          </Menu>
        </MainToolbar>
      </HeaderPortal>
    </>
  );
}
